import { useQuery } from '@tanstack/react-query';
import { getAuditsCompleteThroughDate } from 'services/auditService';

/**
 * Hook to fetch audits complete through date for a specific store
 * 
 * @param storeId - The ID of the store
 * @returns React Query result with audits complete through date data
 */
export function useAuditsCompleteThroughDate(storeId: string | null | undefined) {
  return useQuery({
    queryKey: ['audits-complete-through-date', storeId],
    queryFn: () => getAuditsCompleteThroughDate(storeId!),
    enabled: !!storeId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    retryDelay: 1000,
  });
}
